var parallaxSpeed = 3.5; // higher number is slower
var heroTextTopStart = 55; // match scss file

$(document).ready(function () {
  var $heroParallax = $(".hero-parallax");

  if ($heroParallax.length) {
    var enableTextScroll = $heroParallax.hasClass("text-scroll");
    var enableContentExpand = $heroParallax.hasClass("content-expand");

    controlHeroParallax(enableTextScroll, enableContentExpand);

    $(window).on("scroll", function (event) {
      controlHeroParallax(enableTextScroll, enableContentExpand);
    });

  }

});

function controlHeroParallax(enableTextScroll, enableContentExpand) {
  var $pageWrapper = $(".page-wrapper");
  var currentScrollTop = $(window).scrollTop();
  var pwOffset = $pageWrapper.offset();
  var pwPos = pwOffset.top - currentScrollTop;

  var $heroTextContainer = $(".hero-text-container");
  var heroTextContainerOffset = $heroTextContainer.outerHeight() * 0.45;
  var heroHeight = $heroTextContainer.closest('.hero').outerHeight();
  var navHeight = $('.navigation').outerHeight();
  var minTextPosTop = Math.round(((navHeight + heroTextContainerOffset) / heroHeight) * 100);
  if (pwPos > 0) {
    $(".hero-parallax").css("visibility", "visible");
    if (enableTextScroll) {
      var textPosTop = heroTextTopStart - (((pwOffset.top - pwPos) / Math.pow(parallaxSpeed, 2.5)));
      if (textPosTop > minTextPosTop) {
        $heroTextContainer.css("top", textPosTop + "%");
      }
    }
    if (enableContentExpand) {
      var wrapperPaddingTop = ((pwOffset.top - pwPos) / parallaxSpeed) >= 0.1 ? ((pwOffset.top - pwPos) / parallaxSpeed) : 0.1;
      $pageWrapper.css("paddingTop", wrapperPaddingTop);
    }
  } else {
    $(".hero-parallax").css("visibility", "hidden");
  }
}